setTimeout(() => {
  try {
    window.aegis.reportTime('magic-FCP-1', performance.getEntriesByName('first-paint')[0].startTime);
  } catch (e) {
    console.warn('上报自定义信息失败');
  }
}, 3500);

